import { defaultApi } from '@/plugins/api/defaultApi'
import $store from '@/store'

export default {
  name: 'device',
  namespaced: true,
  state: {
    info: null,
    platform: null,
    callback: null,
    historyLength: window.history.length,
    isSaveFcm: false,
  },
  mutations: {
    setInfo(state, info) {
      state.info = info
      state.platform = 'app'
    },
    setCallback(state, callback) {
      state.callback = callback
    },
    setIsSaveFcs(state, isSaveFcm) {
      state.isSaveFcm = isSaveFcm
    },
  },
  actions: {
    async saveFcm({ state, commit }) {
      if (state.info?.fcm?.token && state.isSaveFcm === false) {
        commit('setIsSaveFcs', true)
        await defaultApi.postFcm({
          deviceId: state.info.deviceId,
          registrationId: state.info.fcm.token,
          type: state.info.platform,
        })
        if ([3, 4].includes($store.state.auth.info.user_id)) {
          alert('전송완료')
        }
      }
    },
  },
}
